import { Button, Divider, Typography } from "antd";
import RateioRelatorioCentroCusto from "../../../../../Models/Financeiro/Titulo/Rateio/RateioRelatorioCentroCusto";
import { useBuscarRelatorioCentroCusto, useListarComProporcionalCalculdo } from "../../../../../Services/Financeiro/Titulo/RateioService"
import Utilitario from "../../../../../Utils/Utilitario";
import RateioRelatorioSituacaoTagsBasic from "./RateioRelatorioSituacaoTagsBasic";
import RateioTableBasic from "./RateioTableBasic";
import TelaCarregamento from "../../../../Base/Carregamento/TelaCarregamento";
import ModalBase, { ModalBaseRefType } from "../../../../Base/ModalBase";
import { Route, Routes } from "react-router-dom";
import TelaPermissao from "../../../../Base/Permissao/TelaPermissao";
import TituloVisualizarModal from "../TituloVisualizarModal";
import { usePermitido } from "../../../../Base/Permissao/ComponentePermissao";
import { useRef } from "react";

const { Text } = Typography;

interface IRateioRelatorioCentroCustoComponenteProps
{
    codCentroCusto:number;
}
export default function RateioRelatorioCentroCustoComponente({
    codCentroCusto
}:IRateioRelatorioCentroCustoComponenteProps) {
    // const navigate = useNavigate();

    const {
        data : dataRelatorioCentroCusto,
        isSuccess : isSuccessRelatorioCentroCusto,
        isPending : isLoadingRelatorioCentroCusto
    } = useBuscarRelatorioCentroCusto({
        codCentroCusto : codCentroCusto
    });

    const {
        data : dataRateios,
        isLoading : isLoadingRateios
    } = useListarComProporcionalCalculdo({
        codCentroCusto : codCentroCusto
    });

    const {
        permitido : permiteFinanceiroTituloBuscarCodigo
    } = usePermitido({
        permissoes : [ "FinanceiroTituloBuscarCodigo" ]
    });

    if (isLoadingRelatorioCentroCusto)
        return <TelaCarregamento />;

    return (
        <>
            <RateioRelatorioSituacaoTagsBasic data={dataRelatorioCentroCusto ?? ({} as RateioRelatorioCentroCusto)} />
            <RateioTableBasic
                loading={isLoadingRateios}
                dataSource={dataRateios ?? []}
                ocultarColunas={[60]}
                scroll={{ x: true }}
                columns={[
                    {
                        title: "Movimentação",
                        key: 1,
                        render(_, record) {
                            return dataRelatorioCentroCusto?.centroCusto?.codEmpresa == record?.titulo?.codBeneficiario ? "Receita" : "Despesa";
                        },
                    },
                    {
                        title: "Devedor",
                        key: 100,
                        dataIndex: ["titulo", "devedor", "nome"],
                    },
                    {
                        title: "Valor previsto",
                        dataIndex: ["titulo", "valorPrevisto"],
                        key: 101,
                        render(v, record) {
                            if (!v) return " - ";
                            const isReceita = dataRelatorioCentroCusto?.centroCusto?.codEmpresa == record?.titulo?.codBeneficiario;
                            return <Text type={isReceita ? "success" : "danger"}>{Utilitario.toStringDinheiro((isReceita ? 1 : -1) * v)}</Text>;
                        },

                        csv: {
                            title: "Previsto (R$)",
                            get: (record) => {
                                const isReceita = dataRelatorioCentroCusto?.centroCusto?.codEmpresa == record?.titulo?.codBeneficiario;
                                return !record?.titulo?.valorPrevisto? " - " : Utilitario.toCSVDinheiro((isReceita ? 1 : -1) * record.titulo.valorPrevisto);
                            }
                        },
                    },
                    {
                        title: "Valor liquidado",
                        dataIndex: ["titulo", "valorRecebido"],
                        key: 102,
                        render(v, record) {
                            if (!v) return " - ";
                            const isReceita = dataRelatorioCentroCusto?.centroCusto?.codEmpresa == record?.titulo?.codBeneficiario;
                            return <Text type={isReceita ? "success" : "danger"}>{Utilitario.toStringDinheiro((isReceita ? 1 : -1) * v)}</Text>;
                        },

                        csv: {
                            title: "Recebido (R$)",
                            get: (record) => {
                                const isReceita = dataRelatorioCentroCusto?.centroCusto?.codEmpresa == record?.titulo?.codBeneficiario;
                                return !record?.titulo?.valorRecebido ? " - " : Utilitario.toCSVDinheiro((isReceita ? 1 : -1) * record.titulo.valorRecebido);
                            }
                        },
                    },
                    {
                        key: 103,
                        dataIndex: ["codTitulo"],
                        title: "Detalhes",
                        hidden: !permiteFinanceiroTituloBuscarCodigo,
                        render(codigo) {
                            return <TituloVisualizarModal codigo={codigo} />;
                        },
                    },
                ]}
            />
        </>
    );
}

